import { Divider as DividerAntd } from 'antd';
import styled, { css } from 'styled-components';

import { handleFontSize, handleWidth } from '../../styles/util';

export const Divider = styled(DividerAntd)`
  top: 0;
  vertical-align: baseline;
  width: 2px;
  height: 16px;
  border-left: 2px solid #9d9d9d;

  ${props =>
    props.iscollapsed &&
    css`
      display: none;
    `}
`;

export const Container = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = styled.img`
  width: ${({ size }) => handleWidth(size)};
  display: inline-block;
  transition: width 0.2s;
`;

export const Name = styled.span`
  font-size: ${({ size }) => handleFontSize(size)};
  font-weight: 500;
  color: #fff;

  ${props =>
    props.iscollapsed &&
    css`
      display: none;
    `}
`;
